import React, { Component } from 'react'
import RemoveIcon from '@material-ui/icons/Remove';
import Checkbox from '@material-ui/core/Checkbox';

 class ToDoItem extends Component {
     getStyle = () => {
         return {
         backgroundColor:"lightgreen",
         padding:"12px",
         borderBottom:"2px black solid",
         textDecoration: this.props.todo.taskcompleted ? 'line-through':'none',
         width : '50%',
         margin : '20px',
         textAlign:"left",
         fontFamily: 'Pacifico'

     }
    
    }
    
    // markCompleted = (e) =>{
    //     console.log(this.props)
    // }
    render() {
       const { id,title} = this.props.todo;
      
        //console.log(this.props.todo.title)
        return ( <center><div style={ this.getStyle()}>
    <p><Checkbox onChange={this.props.markCompleted.bind(this,id)}/>
        {' '} {title} 
        <button onClick={this.props.delItem.bind(this,id)} style={buttonStyle}> <RemoveIcon  fontSize="large"></RemoveIcon></button></p>
             </div></center>
        );
    }
}

const itemStyle={
    backgroundColor:"lightpink"

}
const buttonStyle={
    background:"#Ff3366",
    color:"black",
    border:"none",
    padding:"6px 11px",
    borderRadius:"50%",
    cursor:"pointer",
    float:"right"

}



export default ToDoItem;